var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#8593A3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M1.113 6.475c-.09-.143-.136-.215-.161-.326a.8.8 0 0 1 0-.298c.025-.11.07-.183.161-.327.75-1.188 2.984-4.19 6.387-4.19 3.404 0 5.637 3.002 6.387 4.19.09.144.136.216.162.327.019.083.019.215 0 .298-.026.11-.071.183-.162.326-.75 1.188-2.983 4.192-6.387 4.192S1.864 7.663 1.113 6.475"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#8593A3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M7.5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
})));
export { SvgViewIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/viewIcon.9989b3394d2554c5c35d80f45b308639.svg";